module.exports = __webpack_public_path__ + "r-v3/img/cam_on.6d3053be.svg";